import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function AvisoLegalPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF9F7]">
      <Navbar />
      <main className="pt-36 lg:pt-44 pb-24 lg:pb-32 px-8 md:px-12 lg:px-[8%]">
        <div className="max-w-4xl mx-auto relative">
          <span
            className="absolute -top-4 right-0 text-[140px] lg:text-[180px] font-extrabold text-[#E8DED2]/[0.12] leading-none tracking-[-0.05em] select-none pointer-events-none"
            aria-hidden="true"
          >
            AL
          </span>

          <p className="text-[10px] tracking-[0.35em] uppercase text-[#A39B92] font-medium mb-6">
            LEGAL
          </p>
          <h1 className="text-[clamp(2.5rem,5vw,4rem)] font-bold text-[#111111] leading-tight tracking-[-0.02em] mb-3">
            Aviso Legal
          </h1>
          <div className="w-14 h-[2px] bg-[#D4B896] mb-16"></div>

          <div className="space-y-14 relative z-10">
            <div>
              <h2 className="text-[22px] lg:text-[26px] font-bold text-[#111111] mb-3 tracking-[-0.01em]">
                Titular del sitio web
              </h2>
              <div className="w-8 h-[1px] bg-[#E7CFCF] mb-4"></div>
              <p className="text-[15px] text-[#3A3A3A] leading-[1.8]">LunaFinds</p>
            </div>
            <div>
              <h2 className="text-[22px] lg:text-[26px] font-bold text-[#111111] mb-3 tracking-[-0.01em]">
                Responsable del sitio
              </h2>
              <div className="w-8 h-[1px] bg-[#E7CFCF] mb-4"></div>
              <p className="text-[15px] text-[#3A3A3A] leading-[1.8] mb-3">
                Este es un proyecto digital experimental creado bajo el personaje ficticio
                &quot;Luna García&quot; (generado mediante inteligencia artificial).
              </p>
              <p className="text-[15px] text-[#3A3A3A] leading-[1.8] mb-3">
                Dado el carácter artístico y no comercial del proyecto, no se proporcionan datos
                de identificación fiscal del titular.
              </p>
              <p className="text-[15px] text-[#3A3A3A] leading-[1.8]">
                Para cualquier comunicación legal o consulta, contactar a:{' '}
                <a
                  href="mailto:lunafinds.es@gmail.com"
                  className="text-[#C4727F] underline hover:text-[#A85A66] transition-colors cursor-pointer"
                >
                  lunafinds.es@gmail.com
                </a>
              </p>
            </div>
            <div>
              <h2 className="text-[22px] lg:text-[26px] font-bold text-[#111111] mb-3 tracking-[-0.01em]">
                Correo electrónico de contacto
              </h2>
              <div className="w-8 h-[1px] bg-[#E7CFCF] mb-4"></div>
              <p className="text-[15px] text-[#3A3A3A] leading-[1.8]">
                lunafinds.es@gmail.com
              </p>
            </div>
            <div>
              <h2 className="text-[22px] lg:text-[26px] font-bold text-[#111111] mb-3 tracking-[-0.01em]">
                Actividad del sitio web
              </h2>
              <div className="w-8 h-[1px] bg-[#E7CFCF] mb-4"></div>
              <p className="text-[15px] text-[#3A3A3A] leading-[1.8]">
                Divulgación de contenido sobre productos de belleza, bienestar y hogar. Este sitio
                puede incluir enlaces de afiliado.
              </p>
            </div>
            <div>
              <h2 className="text-[22px] lg:text-[26px] font-bold text-[#111111] mb-3 tracking-[-0.01em]">
                Propiedad intelectual
              </h2>
              <div className="w-8 h-[1px] bg-[#E7CFCF] mb-4"></div>
              <p className="text-[15px] text-[#3A3A3A] leading-[1.8]">
                Todos los contenidos publicados en este sitio web, incluyendo textos, diseño y
                logotipo, están protegidos por derechos de propiedad intelectual. No está permitida
                su reproducción sin autorización expresa.
              </p>
            </div>
            <div>
              <h2 className="text-[22px] lg:text-[26px] font-bold text-[#111111] mb-3 tracking-[-0.01em]">
                Responsabilidad
              </h2>
              <div className="w-8 h-[1px] bg-[#E7CFCF] mb-4"></div>
              <p className="text-[15px] text-[#3A3A3A] leading-[1.8]">
                La información publicada tiene carácter informativo y no sustituye asesoramiento
                profesional. El titular no se hace responsable del uso indebido de la información
                contenida en este sitio.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
